import type { CSSProperties } from "react";
import styles from "./Spinner.module.css";

export function Spinner({ large = false }: { large?: boolean }) {
  const classes = [styles.spinner, large ? styles.large : null]
    .filter(Boolean)
    .join(" ");
  return <div className={classes} role="status" aria-label="Indlæser" />;
}

export interface SkeletonProps {
  /** Bredde/højde som CSS-værdier; default fylder bredden i én tekstlinje. */
  width?: string;
  height?: string;
}

/** Pladsholder under indlæsning — brug i stedet for spinner ved kendt layout. */
export function Skeleton({ width = "100%", height = "1rem" }: SkeletonProps) {
  const style: CSSProperties = { width, height };
  return <div className={styles.skeleton} style={style} aria-hidden="true" />;
}
